import { RuleTableHandlers, TableConfig } from "../../../../../shared/ui/custom-table/model/table-config.model";

export function createCustomerAdvancePaymentTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string, defaultFilter?: any } = {}
): TableConfig {
  const {
    onCreate = () => { },
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    selectable = false,
    summaryTemplate = () => { },
    rowConfig = {},
    headerActions,
    gridActions,
    columns,
  } = handlers;

  const handleAction = (row: any, action: TableRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
  const isAssigned = (row: any) => row && row.invoiceUid && row.invoiceUid !== EMPTY_GUID;

  return {
    columns: columns,
    actions: [
      {
        label: 'Asignar a factura',
        icon: 'link',
        visible: (row) => !isAssigned(row),
        callback: (row) => handleAction(row, TableRowAction.AssignIncome),
      },
      {
        label: 'Editar',
        icon: 'edit',
        visible: (row) => !isAssigned(row),
        callback: (row) => handleAction(row, TableRowAction.Edit),
      },
      {
        label: 'Eliminar',
        icon: 'delete',
        callback: (row) => handleAction(row, TableRowAction.Delete),
      },
    ],
    gridActions: gridActions,
    headerActions: headerActions,
    filterView: options.filterView || 'viewSummaryCustomerAdvancePaymentFilters',
    defaultFilter: options.defaultFilter || {},
    rowConfig: {
      ...rowConfig,
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand,
    },
    selectable: selectable,
    pagination: false,
    summaryTemplate: summaryTemplate,
  };
}

export enum TableRowAction {
  AssignIncome = 'assignIncome',
  Edit = 'edit',
  Delete = 'delete',
}
